import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CatalogPage from '../components/CatalogPage';
import Image from '../components/Image';
import { useCatalogState } from '../hooks/useCatalogState';
import { extractShareMapFromSearch } from '../lib/shareState';

export default function SharedTopPage() {
  const location = useLocation();
  const sharedMap = useMemo(() => extractShareMapFromSearch(location.search), [location.search]);
  const state = useCatalogState('character', { persist: false, sharedMap });

  if (state.loading) {
    return null;
  }

  return (
    <CatalogPage
      title="共有されたキャラクター所持状況"
      state={state}
      onTogglePossession={() => { }}
      onSetRarity={() => { }}
      interactive={false}
      rarityOptions={[]}
      renderRarityControl={(item) => {
        const selected = Number(item.rarity || 0);
        const stars = [1, 2, 3, 4, 5];
        const hexes = [6, 7, 8];

        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 0.8,
              opacity: item.possessed ? 1 : 0.3,
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.1 }}>
              {stars.map((value) => {
                const active = selected >= value;
                return (
                  <Box
                    key={`star-${value}`}
                    sx={{
                      fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.85rem' },
                      lineHeight: 1,
                      color: active ? '#facc15' : 'rgba(255,255,255,0.15)',
                      textShadow: active ? '0 0 10px rgba(250, 204, 21, 0.8)' : 'none',
                    }}
                  >
                    ★
                  </Box>
                )
              })}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.2, mt: 0.4 }}>
              {hexes.map((value) => {
                const active = selected >= value;
                return (
                  <Box
                    key={`hex-${value}`}
                    sx={{
                      fontSize: { xs: '0.55rem', sm: '0.65rem', md: '0.75rem' },
                      lineHeight: 1,
                      color: active ? '#ec4899' : 'rgba(255,255,255,0.15)',
                      textShadow: active ? '0 0 10px rgba(236, 72, 153, 0.8)' : 'none',
                    }}
                  >
                    ⬢
                  </Box>
                )
              })}
            </Box>
          </Box>
        );
      }}
      renderMainImage={(item) => (
        <Image
          src={`/img/chara/${item.id}.png`}
          alt={item.name}
          style={{
            width: '100%',
            aspectRatio: '1 / 1',
            objectFit: 'cover',
            filter: item.possessed ? 'none' : 'grayscale(100%)',
          }}
        />
      )}
    />
  );
}
